import React from 'react';
import thunk from 'redux-thunk';
import { Provider } from 'react-redux';
import { datadogRum } from '@datadog/browser-rum';

import { middleware as analyticsMiddleware } from '@eb/site-analytics';
import { configureStore } from '@eb/redux-configure-store';

import { minimalInitialState } from './redux';
import { rootReducer } from './redux/root';
import { isProd } from '../../utils/http';

import { HomeBaseContainer } from './containers/HomeBaseContainer';

export default class HomePage extends React.Component {
    constructor(props) {
        super(props);

        // creates a store w/ Redux logging defaulted in development environment
        // also adds `redux-thunk` middleware by default for async actions
        this._store = configureStore({
            reducer: rootReducer,
            initialState: minimalInitialState(props),
            middleware: [thunk, analyticsMiddleware(props)],
        });
    }

    componentDidMount() {
        if (isProd(this.props)) {
            datadogRum.addRumGlobalContext('view.sub_app', 'home');
        }
    }

    render() {
        return (
            <Provider store={this._store}>
                <HomeBaseContainer {...this.props} />
            </Provider>
        );
    }
}
